import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { ThemeProvider } from 'react-bootstrap'

const { instanceOf } = PropTypes
import { Cookies } from 'react-cookie'
import withSafeCookies from './withSafeCookies'

import axios from 'axios'

import { Helmet } from 'react-helmet'

import Header from './block/Header'
import Footer from './block/Footer'
import TopSearch from './block/TopSearch'
import LeftMenuh from './block/LeftMenuh'
import InCart from './block/InCart'
import MobFMenu from './block/MobFMenu'

import Main from './pages/Main'
import Razdel from './pages/Razdel'
import Product from './pages/Product'
import Lk from './pages/Lk'
import Orders from './pages/Orders'
import Favorite from './pages/Favorite'
import Adresa from './pages/Adresa'
import Korzina from './pages/Korzina'
import Oformlen from './pages/Oformlen'
import Oformlenie from './pages/Oformlenie'
import IndividualnyijPoshiv from './pages/IndividualnyijPoshiv'
import AboutBrand from './pages/AboutBrand'
import Butik from './pages/Butik'
import OplataIDostavka from './pages/OplataIDostavka'
import TextPage from './pages/TextPage'
import PodarochnyieKartyi from './pages/PodarochnyieKartyi'

import './custom.scss'

class App extends Component {

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  }

  constructor(props) {
    super(props)
    const { cookies } = props

    this.state = {
      loading: props?.data.loaded == false || true,
      pages: {},
      page_data: props?.data.page_data || null,
      catalogmenu: props?.data.catalogmenu || [],
      router_data: props?.data.router_data || [],
      ajax_data: props?.ajax_data || null,
      search: ``,
      top_search: false,
      search_loading: false,
      search_result: null,
      left_menu: false,
      in_cart_show: false,
      in_cart_loading: false,
      in_cart: {},
      cart: cookies.get('imidj_cart') || [],
      favorite: cookies.get('imidj_favorite') || [],
      scrollY: 0,
      clientWidth: 380,
      prevPathname: ``
    }
  }

  changeSearch = (search) => {
    this.setState({
      search: search
    })
  }

  changeTopSearch = ( sst = null ) => {
    if(sst == null) sst = !this.state.top_search
    if(sst) {
      const { search } = this.state
      if( search.length > 3 ) {
        const main = this,
        baseURL = window.location.protocol + "//" + window.location.hostname
        this.setState({
          search_loading: true,
          search_result: null
        }, () => {
          axios.post(`${baseURL}`, {
            'content_type': 'application/json',
            'action': 'find_products',
            'query': search
          }).then( ( response ) => {
            main.setState({
              search_loading: false,
              search_result: response.data
            })
          })
        })
      } else {
        this.setState({
          search_loading: false,
          search_result: null
        })
      }
    }
    this.setState({
      top_search: sst
    })
  }

  changeLeftMenuh = () => {
    this.setState({
      left_menu: !this.state.left_menu
    })
  }

  showInCart = ( id, var_id = '' ) => {
    const main = this,
    baseURL = window.location.protocol + "//" + window.location.hostname

    this.setState({
      in_cart_loading: true
    }, () => {
      axios.post(`${baseURL}`, {
        'content_type': 'application/json',
        'action': 'load_product_small_cart',
        'id': id
      }).then( ( response ) => {
        if( response.data.fined ) {
          let data = response.data
          data.var_id = var_id
          main.setState({
            in_cart: data,
            in_cart_show: true,
            in_cart_loading: false
          })
        }
      })
    })
  }

  closeInCart = () => {
    this.setState({
      in_cart_show: false
    })
  }

  addTocart = ( elm, fnc = null ) => {
    const { cart } = this.state
    const { cookies } = this.props
    var fined = false
    if(elm.variant == null) {
      cart.map(( celm, k ) => {
        if( elm.product == celm.product && celm.variant == null ) {
          if( elm.count < 1 ) {
            cart.splice(k, 1)
          } else {
            cart[ k ].count = elm.count
          }
          fined = true
        }
      })
    } else {
      cart.map(( celm, k ) => {
        if( elm.product == celm.product && elm.variant == celm.variant ) {
          if( elm.count < 1 ) {
            cart.splice(k, 1)
          } else {
            cart[ k ].count = elm.count
          }
          fined = true
        }
      })
    }
    if(!fined) cart.push( elm )

    cookies.set('imidj_cart', cart, { path: '/' })
    this.setState({
      cart: cart,
      in_cart_show: false
    }, () => {
      if( fnc != null ) fnc()
    })
  }

  clearCart = ( fnc = null ) => {
    const { cookies } = this.props
    cookies.set('imidj_cart', [], { path: '/' })
    this.setState({
      cart: []
    }, () => {
      if( fnc != null ) fnc()
    })
  }

  changeFavorite = ( el ) => {
    const { favorite } = this.state
    const { cookies } = this.props

    if( favorite.includes( el ) ) {
      var index = favorite.indexOf( el )
      if (index !== -1) favorite.splice(index, 1)
    } else {
      favorite.push( el )
    }

    cookies.set('imidj_favorite', favorite, { path: '/' })
    this.setState({
      favorite: favorite
    })
  }

  componentDidMount() {
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  handleScroll() {
    this.setState({
      scrollY: window.scrollY || window.pageYOffset
    });
  }

  handleResize() {
    this.setState({
      clientWidth: document.body.clientWidth
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  renderContent() {
    const {
      ajax_data,
      page_data,
      catalogmenu,
      search,
      in_cart_loading,
      favorite,
      cart,
      clientWidth
    } = this.state

    const { get = {} } = this.props

    if ('template' in ajax_data == false) {
      return <p>Данные не загружены</p>
    }

    switch(ajax_data.template) {
      case 1:
        return (
          <Main
            ajax_data={ajax_data}
            page_data={page_data}
            catalogmenu={catalogmenu}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            search={search}
            changeSearch={this.changeSearch}
            showInCart={this.showInCart}
            in_cart_loading={in_cart_loading}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            clientWidth={clientWidth}
          />
        );
      case 2:
        return (
          <Razdel
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            clientWidth={clientWidth}
            in_cart_loading={in_cart_loading}
            showInCart={this.showInCart}
            catalogmenu={catalogmenu}
            new_page={false}
          />
        );
      case 3:
        return (
          <Product
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            showInCart={this.showInCart}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            in_cart_loading={in_cart_loading}
            addTocart={this.addTocart}
            clientWidth={clientWidth}
            get={get}
          />
        );
      case 5:
        return (
          <AboutBrand
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            clientWidth={clientWidth}
            in_cart_loading={in_cart_loading}
            showInCart={this.showInCart}
          />
        );
      case 6:
        return (
          <Butik
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            clientWidth={clientWidth}
            in_cart_loading={in_cart_loading}
            showInCart={this.showInCart}
          />
        );
      case 7:
        return (
          <OplataIDostavka
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            in_cart_loading={in_cart_loading}
            showInCart={this.showInCart}
          />
        );
      case 8:
        return (
          <TextPage
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            in_cart_loading={in_cart_loading}
            showInCart={this.showInCart}
          />
        );
      case 9:
        return (
          <Lk
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            search={search}
            changeSearch={this.changeSearch}
            favorite={favorite}
            cart={cart}
          />
        );
      case 10:
        return (
          <Orders
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            search={search}
            changeSearch={this.changeSearch}
            favorite={favorite}
            cart={cart}
            in_cart_loading={in_cart_loading}
            changeFavorite={this.changeFavorite}
            showInCart={this.showInCart}
            clientWidth={clientWidth}
          />
        );
      case 11:
        return (
          <Favorite
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            search={search}
            changeSearch={this.changeSearch}
            favorite={favorite}
            cart={cart}
            in_cart_loading={in_cart_loading}
            changeFavorite={this.changeFavorite}
            showInCart={this.showInCart}
          />
        );
      case 12:
        return (
          <Adresa
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            search={search}
            changeSearch={this.changeSearch}
            favorite={favorite}
            cart={cart}
            in_cart_loading={in_cart_loading}
            changeFavorite={this.changeFavorite}
            showInCart={this.showInCart}
          />
        );
      case 13:
        return (
          <Korzina
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            in_cart_loading={in_cart_loading}
            showInCart={this.showInCart}
            addTocart={this.addTocart}
          />
        );
      case 14:
        return (
          <Oformlenie
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            in_cart_loading={in_cart_loading}
            showInCart={this.showInCart}
            addTocart={this.addTocart}
            clearCart={this.clearCart}
          />
        );
      case 15:
        return (
          <Oformlen
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            in_cart_loading={in_cart_loading}
            showInCart={this.showInCart}
          />
        );
      case 16:
        return (
          <Razdel
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            clientWidth={clientWidth}
            in_cart_loading={in_cart_loading}
            showInCart={this.showInCart}
            catalogmenu={catalogmenu}
            new_page={true}
          />
        );
      case 17:
        return (
          <IndividualnyijPoshiv
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            in_cart_loading={in_cart_loading}
            showInCart={this.showInCart}
          />
        );
      case 18:
        return (
          <PodarochnyieKartyi
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={this.changeTopSearch}
            changeLeftMenuh={this.changeLeftMenuh}
            search={search}
            changeSearch={this.changeSearch}
            favorite={favorite}
            changeFavorite={this.changeFavorite}
            cart={cart}
            in_cart_loading={in_cart_loading}
            showInCart={this.showInCart}
            addTocart={this.addTocart}
          />
        );
      default:
        return <p>Шаблон страницы не распознан</p>;
    }
  }

  render() {

    const {
      ajax_data,
      page_data,
      catalogmenu,
      search,
      top_search,
      search_loading,
      search_result,
      left_menu,
      in_cart_show,
      in_cart,
      cart,
      favorite,
      scrollY,
      clientWidth
    } = this.state

    return (
      <ThemeProvider
        breakpoints={['xl', 'lg', 'md', 'sm', 'xs']}
        minBreakpoint="xs"
      >
        <Helmet>
          <title>{ajax_data?.helmet.title || 'brunoaltro.ru'}</title>

          <base href={`https://${'brunoaltro.ru'}/`} />

          <meta name="viewport" content="width=device-width, initial-scale=1.0" />

          <meta name="description" content={ajax_data?.helmet.description || 'brunoaltro.ru'} />

          {/*<React.Fragment dangerouslySetInnerHTML={{ __html: ajax_data?.helmet.meta }} />*/}

          <link rel="canonical" href={ajax_data?.helmet.canonical || `https://${'brunoaltro.ru'}/`} />

          <link rel="icon" href="files/images/aboutng_image.svg" type="image/svg+xml" />

          <script type="text/javascript">   
            var digiScript = document.createElement('script');   
            digiScript.src = '//aq.dolyame.ru/8647/client.js'; //    
            digiScript.defer = true;   
            digiScript.async = true;   
            document.head.appendChild(digiScript);   
          </script>
        </Helmet>
        <div className='d-flex flex-column' style={{ minHeight: `100vh` }}>
          <Header
            changeLeftMenuh={this.changeLeftMenuh}
            changeTopSearch={this.changeTopSearch}
            favorite={favorite}
            cart={cart}
            scrollY={scrollY}
            clientWidth={clientWidth}
            page_data={page_data}
          />
          {this.renderContent()}
          <Footer
            changeTopSearch={this.changeTopSearch}
            favorite={favorite}
            cart={cart}
            page_data={page_data}
            catalogmenu={catalogmenu}
          />
        </div>
        <MobFMenu
          changeLeftMenuh={this.changeLeftMenuh}
          changeTopSearch={this.changeTopSearch}
          favorite={favorite}
          cart={cart}
          page_data={page_data}
        />
        <TopSearch
          search={search}
          changeSearch={this.changeSearch}
          changeTopSearch={this.changeTopSearch}
          top_search={top_search}
          loading={search_loading}
          result={search_result}
        />
        <LeftMenuh
          changeLeftMenuh={this.changeLeftMenuh}
          left_menu={left_menu}
          changeTopSearch={this.changeTopSearch}
          favorite={favorite}
          cart={cart}
          catalogmenu={catalogmenu}
          page_data={page_data}
          ajax_data={ajax_data}
        />
        <InCart
          in_cart_show={in_cart_show}
          in_cart={in_cart}
          closeInCart={this.closeInCart}
          clientWidth={clientWidth}
          addTocart={this.addTocart}
        />
      </ThemeProvider>
    )
  }
}

App.propTypes = {
  data: PropTypes.shape({
    loaded: PropTypes.bool,
    router_data: PropTypes.array,
    catalogmenu: PropTypes.array,
    page_data: PropTypes.object
  }),
  ajax_data: PropTypes.object,
  get: PropTypes.object
}

export default withSafeCookies(App)